import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums';

const GetCutOffList = (param: any) =>
    request({
        url: ApiURL.Command.GetCutOffList,
        method: RequestType.POST,
        data: param,
    });

const UpsertBulkShippingCompanyCutOff = (param: any) =>
    request({
        url: ApiURL.Command.UpsertBulkShippingCompanyCutOff,
        method: RequestType.POST,
        data: param,
    });

const CutOffCommand = {
    GetCutOffList,
    UpsertBulkShippingCompanyCutOff,
};

export default CutOffCommand;
